import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'
import { JwtHelperService } from '@auth0/angular-jwt'
import { Observable } from 'rxjs'
import { AuthService } from './auth.service';
import { environment } from 'projects/environments/environment';


@Injectable()
export class APIInterceptor implements HttpInterceptor {
  auth: string
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.api_server) {
      console.error('API Server not set. Set it in environments/environment.ts')
      return next.handle(req);
    }

    req.headers.append('authorization', AuthService.token())

    const newReq = req.clone({
      headers: req.headers,
      url: `${environment.api_server}${req.url}`
    });

    return next.handle(newReq);
  }
}
